import React from 'react';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Switch } from '@/components/ui/switch';

/** Compact edit dialog for a tenant's headline fields (name / domain / plan / is_demo). */
export const EditTenantDialog = ({ open, onOpenChange, formData, setFormData, plans, saving, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-slate-50 border-slate-200 text-slate-900">
      <DialogHeader>
        <DialogTitle className="text-slate-900">Editar Cliente</DialogTitle>
      </DialogHeader>

      <div className="space-y-4">
        <div>
          <Label className="text-slate-600">Nome</Label>
          <Input
            value={formData.name}
            onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
            className="bg-white border-slate-300 text-slate-900"
          />
        </div>
        <div>
          <Label className="text-slate-600">Domínio</Label>
          <Input
            value={formData.domain || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, domain: e.target.value }))}
            className="bg-white border-slate-300 text-slate-900"
          />
        </div>
        <div>
          <Label className="text-slate-600">Plano</Label>
          <Select value={formData.plan} onValueChange={(v) => setFormData(prev => ({ ...prev, plan: v }))}>
            <SelectTrigger className="bg-white border-slate-300 text-slate-900" data-testid="edit-tenant-plan-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-white border-slate-300">
              {plans.map(plan => (
                <SelectItem key={plan.key} value={plan.key} className="text-slate-900 hover:bg-slate-700">
                  {plan.name} ({plan.max_users === -1 ? '∞' : plan.max_users} users, {plan.max_reports_month === -1 ? '∞' : plan.max_reports_month}/mês)
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <p className="text-xs text-slate-500 mt-1">Sincronizado com o Hub via /provisioning/plans.</p>
        </div>

        <div className="flex items-start justify-between gap-4 pt-2 border-t border-slate-200">
          <div className="flex-1">
            <Label className="text-slate-700 font-semibold">Instância de teste (is_demo)</Label>
            <p className="text-xs text-slate-500 mt-1">
              Marque como teste para permitir "Repor dados de teste" (apaga todas as denúncias e email_logs mantendo utilizadores e definições).
              Use em sandboxes, staging ou tenants demo. <strong>Nunca ligar em produção.</strong>
            </p>
          </div>
          <Switch
            checked={!!formData.is_demo}
            onCheckedChange={(v) => setFormData(prev => ({ ...prev, is_demo: !!v }))}
            data-testid="edit-tenant-is-demo-toggle"
          />
        </div>
      </div>

      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)} className="border-slate-300 text-slate-600 hover:bg-slate-700">
          Cancelar
        </Button>
        <Button onClick={onSubmit} disabled={saving} className="bg-indigo-700 hover:bg-amber-600 text-black">
          {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
          Guardar
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
